import React from "react";
import { DashboardContentWrapper, SearchFilterGroup } from "Components/Admin/AdminDashboard/AdminDashboard.styled";
import { Box, Checkbox, FormControlLabel, Popover, Stack, TextField, Typography, InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export const AdminDashboard = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? "dashboard-item-filter" : undefined;

  return (
    <DashboardContentWrapper>
      <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" p={4}>
        <Typography variant="h6" fontWeight="600">Quick Search</Typography>
        <Stack direction="row" gap={2}>
          <TextField placeholder="Search" size="small"
            InputProps={{
              startAdornment:
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
            }}
          />
          <Box>
            <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} aria-describedby={id} color="primary">
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
            <Popover id={id} open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <SearchFilterGroup>
                <FormControlLabel control={<Checkbox defaultChecked />} label="Label" />
                <FormControlLabel control={<Checkbox />} label="Required" />
                <FormControlLabel control={<Checkbox />} label="Required" />
                <FormControlLabel control={<Checkbox />} label="Required" />
              </SearchFilterGroup>
            </Popover>
          </Box>
        </Stack>
      </Stack>
    </DashboardContentWrapper>
  );
};